import React from 'react';

export default function CompanyLogosMarquee()  {
  const companyLogos = [
    {
      name: "Deloitte Shared Services LLP",
      logo: "http://www2.deloitte.com/content/dam/assets/logos/Deloitte_logo_PRI.svg",
      officialUrl: "https://www2.deloitte.com/in/en.html"
    },
    {
      name: "Saint-Gobain - Gyproc India Pvt Ltd",
      logo: "https://www.gyproc.ae/sites/mac3.saint-gobain.ae/files/Gyproc_Logo_RGB.png",
      officialUrl: "https://www.gyproc.in/"
    },
    {
      name: "Worldline Pvt Ltd",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRs6BCru3tTLeptUMFc1cg1G-BqIm0yzCcISQ&s",
      officialUrl: "https://worldline.com/"
    },
    {
      name: "1Pay Mobileware Private Limited",
      logo: "https://media.licdn.com/dms/image/v2/C4E0BAQGIoaqEn9lk-Q/company-logo_200_200/company-logo_200_200/0/1631328753629?e=2147483647&v=beta&t=566235uU5ZiIxp1CkXmV3rIH08t0VR_Kk2EudbUvH5Q",
      officialUrl: "https://www.1pay.in/"
    },
    {
      name: "RTCom Nigeria Ltd",
      logo: "https://rtc-ltd.com/wp-content/uploads/2024/05/snapedit_1718870117016-removebg-preview.png",
      officialUrl: "https://rtc-ltd.com/"
    },
    {
      name: "Mumbai Police",
      logo: "https://upload.wikimedia.org/wikipedia/en/thumb/1/13/Mumbai_Police_logo.png/280px-Mumbai_Police_logo.png",
      officialUrl: "https://mumbaipolice.gov.in/"
    },
    {
      name: "PayNearby Technologies Pvt Ltd",
      logo: "https://paynearby.in/wp-content/themes/paynearby/src/images/logo.png",
      officialUrl: "https://paynearby.in/"
    },
    {
      name: "Narotam Sekhsaria Foundation",
      logo: "https://nsfoundation.co.in/wp-content/uploads/2024/02/nsf-logo.jpg",
      officialUrl: "https://nsfoundation.co.in/"
    },
    {
      name: "SME Corner Pvt Ltd",
      logo: "https://media.licdn.com/dms/image/v2/D4D0BAQHnHMqb1Fysrg/company-logo_200_200/company-logo_200_200/0/1665736933430/smecorner_com_logo?e=2147483647&v=beta&t=R9U6hsOV7wCN4QtXF8QAusyEZbi40ihZVsL7ZwXwp-0",
      officialUrl: "https://www.smecorner.com/"
    },
    {
      name: "Serum Institute of India Pvt Ltd",
      logo: "https://www.seruminstitute.com/images/retina/serum-logo.png",
      officialUrl: "https://www.seruminstitute.com/"
    },
    {
      name: "Blue Star India Limited",
      logo: "https://www.bluestarindia.com/img/logo.png",
      officialUrl: "https://www.bluestarindia.com/"
    },
    {
      name: "Cruise AC",
      logo: "https://5.imimg.com/data5/SELLER/Default/2023/6/316725637/EN/DA/RG/38941546/1-2-.jpg",
      officialUrl: "https://www.cruiseac.com/"
    },
    {
      name: "Cleartrip",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ae/Cleartrip_Original.svg/1920px-Cleartrip_Original.svg.png",
      officialUrl: "https://www.cleartrip.com/"
    },
    {
      name: "Blinktrip",
      logo: "https://www.blinktrip.com/img/blinktripLogo-color-1.svg",
      officialUrl: "https://www.blinktrip.com/"
    },
    {
      name: "Plum Goodness",
      logo: "https://plumgoodness.com/cdn/shop/files/logo.png",
      officialUrl: "https://plumgoodness.com/"
    },
    {
      name: "Vivo",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Vivo_logo_2019.svg/2560px-Vivo_logo_2019.svg.png",
      officialUrl: "https://www.vivo.com/"
    },
    {
      name: "Axis Bank",
      logo: "https://www.axisbank.com/assets/images/logo.png",
      officialUrl: "https://www.axisbank.com/"
    },
    {
      name: "ICICI Prudential Life Insurance Company Ltd",
      logo: "https://www.iciciprulife.com/content/icici-prudential-life-insurance/_jcr_content/headerpar/header_sightly/navHeader.img.png/1533272453567.png",
      officialUrl: "https://www.iciciprulife.com/"
    },
    {
      name: "Mahindra & Mahindra Finance Ltd",
      logo: "https://www.mahindrafinance.com/wp-content/uploads/2023/05/mahindra-finance-logo.png",
      officialUrl: "https://www.mahindrafinance.com/"
    },
    {
      name: "LANXESS India Pvt Ltd",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxyOHMpc0_zYoczG32Qgj22HGWwqbZmxsh_Q&s",
      officialUrl: "https://lanxess.com/"
    },
    {
      name: "TATA AIA Life Insurance",
      logo: "https://www.tataaia.com/content/dam/tataaialifeinsurancecompanylimited/navigations/new-navigation-icon/Logo.svg",
      officialUrl: "https://www.tataaia.com/"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-slate-50 to-gray-100 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Trusted by Leading Companies
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We're proud to work with industry leaders and innovative companies across various sectors
          </p>
        </div>
        
        {/* <div className="relative">
           <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-slate-50 to-transparent z-10"></div>
          <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-slate-50 to-transparent z-10"></div>
          
          <div className="marquee-container overflow-hidden">
            <div className="marquee-content flex animate-scroll-once">
              {companyLogos.map((client, index) => (
                <div key={index} className="logo-item flex-shrink-0 mx-8">
                  <a 
                    href={client.officialUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    title={client.name}
                    className="block transition-transform duration-300 hover:scale-110 hover:shadow-lg"
                  >
                    <img 
                      src={client.logo} 
                      alt={client.name} 
                      className="h-12 w-auto object-contain transition-all duration-300"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>
      
      <style jsx>{`
        @keyframes scroll-once {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-510%);
          }
        }
        
        .animate-scroll-once {
          animation: scroll-once 25s linear infinite;
        }
        
        .marquee-container:hover .animate-scroll-once {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}
